<ngx-smart-modal [identifier]="MODAL_ID" customClass="nsm-modal-lg" #formErrorsDebug>
  <h4>Errori — {{ debug.title$ | async }}</h4>

  <ng-container *ngIf="(debug.entries$ | async) as entries">
    <p *ngIf="entries.length === 0">Nessun errore in questa sezione.</p>

    <table *ngIf="entries.length > 0" class="table table-sm form-errors-debug-table">
      <thead>
        <tr>
          <th>Macrosezione</th>
          <th>Campo</th>
          <th>Errore</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let e of entries">
          <td>{{ e.section }}</td>
          <td>
            <code>{{ e.field }}</code>
          </td>
          <td>{{ e.errorLabel }}</td>
        </tr>
      </tbody>
    </table>
  </ng-container>
</ngx-smart-modal>
